import React, { useState } from 'react';
import { sendPasswordResetLink } from '../services/authService'; // API call to send reset link
import '../forgotPassword.css';  // Ensure this import is at the top of your component file

const ForgotPasswordPage = () => {
  const [email, setEmail] = useState('');
  const [showPopup, setShowPopup] = useState(false);  // Pop-up visibility state
  const [popupMessage, setPopupMessage] = useState('');  // Message to be displayed in the pop-up

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!email) {
      setPopupMessage('Please provide an email address.');
      setShowPopup(true);  // Show pop-up for error message
      return;
    }

    try {
      // Send the password reset email with the provided email address
      await sendPasswordResetLink({ email });  // No need to store the response
      setPopupMessage('Mail sent successfully! Please check your email.');
      setShowPopup(true);  // Show pop-up for success message
    } catch (err) {
      setPopupMessage('Error sending reset link. Please try again.');
      setShowPopup(true);  // Show pop-up for error message
    }
  };

  const closePopup = () => {
    setShowPopup(false);  // Close pop-up when the user clicks "OK"
  };

  return (
    <div className='forgot-password-page'>
      <h2>Forgot Password</h2>
      <form onSubmit={handleSubmit} className="forgot-password-container">
        <div>
          <label>Enter your email:</label>
          <input
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />
        </div>
        <button type="submit">Send Reset Link</button>
      </form>

      {/* Popup Window for Success/Error */}
      {showPopup && (
        <div className="popup-overlay">
          <div className="popup-content">
            <h4>{popupMessage}</h4>
            <button className="btn btn-success" onClick={closePopup}>OK</button>
          </div>
        </div>
      )}
    </div>
  );
};

export default ForgotPasswordPage;
